import createUsersApi from './users';
import createPagesApi from './pages';
import createCompetitionsApi from './competitions';
import createEventsApi from './events';
import createAppearanceApi from './appearance';
import createSponsorsApi from './sponsors';
import createCampaignsApi from './campaigns';
import createCountriesApi from './countries';
import createRegionsApi from './regions';
import createArticlesApi from './articles';
import createAthletesApi from './athletes';
import createDisciplinesApi from './disciplines';
import createDocumentsApi from './documents';
import createEmailsApi from './emails';
import createAudiencesApi from './audiences';
import createTagsApi from './tags';
import createMediaApi from './media';
import createMediaTagsApi from './mediaTags';
import createMenusApi from './menus';
import createLiveBlogsApi from './liveBlogs';
import createPostsApi from './posts';
import createBooksApi from './books';
import createChaptersApi from './chapters';
import createSectionsApi from './sections';
import createRulesApi from './rules';
import createLocationsApi from './locations';
import createMinisitesApi from './minisites';
import createLanguagesApi from './languages';
import createVocabularyApi from './vocabulary';
import createTranslationsApi from './translations';
import createCisUsersApi from './cisUsers';
import createAssetsApi from './assets';
import createFiltersApi from './filters';
import createFlashInterviewsApi from './flashInterviews';
import createGettyImagesApi from './gettyImages';
import createWhereToWatch from './whereToWatch';
import createChannelsApi from './channels';
import createSchedulesApi from './schedules';
import createVideosApi from './videos';
import createVideoPlaylistApi from './video-playlists';
import createGameBannersApi from './gameBanners';
import createGameNotificationsApi from './gameNotifications';
import createWinModuleApi from './winModule';
import createStatsZoneUserApi from './statsZoneUsers';
import createMedalCeremonyUsersApi from './medalCeremonyUsers';

export default {
  users: createUsersApi(),
  pages: createPagesApi(),
  competitions: createCompetitionsApi(),
  events: createEventsApi(),
  appearance: createAppearanceApi(),
  sponsors: createSponsorsApi(),
  campaigns: createCampaignsApi(),
  countries: createCountriesApi(),
  regions: createRegionsApi(),
  articles: createArticlesApi(),
  athletes: createAthletesApi(),
  disciplines: createDisciplinesApi(),
  documents: createDocumentsApi(),
  emails: createEmailsApi(),
  audiences: createAudiencesApi(),
  tags: createTagsApi(),
  media: createMediaApi(),
  mediaTags: createMediaTagsApi(),
  menus: createMenusApi(),
  liveBlogs: createLiveBlogsApi(),
  posts: createPostsApi(),
  books: createBooksApi(),
  chapters: createChaptersApi(),
  sections: createSectionsApi(),
  rules: createRulesApi(),
  locations: createLocationsApi(),
  minisites: createMinisitesApi(),
  languages: createLanguagesApi(),
  vocabulary: createVocabularyApi(),
  translations: createTranslationsApi(),
  cisUsers: createCisUsersApi(),
  statsZoneUsers: createStatsZoneUserApi(),
  medalCeremonyUsers: createMedalCeremonyUsersApi(),
  assets: createAssetsApi(),
  filters: createFiltersApi(),
  flashInterviews: createFlashInterviewsApi(),
  gettyImages: createGettyImagesApi(),
  whereToWatch: createWhereToWatch(),
  channels: createChannelsApi(),
  schedules: createSchedulesApi(),
  videos: createVideosApi(),
  playlists: createVideoPlaylistApi(),
  gameBanners: createGameBannersApi(),
  gameNotifications: createGameNotificationsApi(),
  winModule: createWinModuleApi(),
};
